import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Star } from '../../../../../../editJournal/toolset/assets/icons';
import breakpointsMinWidth from '../../../../../../../../../styling/breakpointsMinWidth';

const RatingWrapper = styled.span`
  height: 100%;
  display: flex;
  align-items: center;
`;

const StarWrapper = styled.span`
  cursor: pointer;

  /* svg {
    @media ${breakpointsMinWidth.tabletMd} {
      width: 20px;
      height: 20px;
    }

    @media ${breakpointsMinWidth.desktopSm} {
      width: 24px;
      height: 24px;
    }
  } */
`;

const Rating = (props) => {
  const { node, isFocused } = props;
  const { data, key: nodeKey } = node;
  const rating = data.get('rating');

  const updateRating = (e, val) => {
    e.stopPropagation();
    e.preventDefault();

    const { editor } = props;

    const dataJSON = data.toJSON();

    let updatedRating;
    if (val !== rating) {
      updatedRating = val;
    } else {
      updatedRating = 0;
    }

    editor
      .setNodeByKey(nodeKey, {
        data: {
          ...dataJSON,
          rating: updatedRating,
        },
      })
      .moveToEndOfNode(node)
      .focus();
  };

  return (
    <RatingWrapper>
      {[1, 2, 3, 4, 5].map((val) => (
        <StarWrapper
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            updateRating(e, val);
          }}
          key={val}
        >
          <Star
            width="16px"
            height="16px"
            fill={
              val <= rating
                ? `${isFocused ? '#F2994A' : 'rgba(242, 153, 74, 0.5)'}`
                : '#E5E5E5'
            }
            // stroke={val > rating && '#95989A'}
          />
        </StarWrapper>
      ))}
    </RatingWrapper>
  );
};

Rating.propTypes = {
  node: propTypes.objectOf(propTypes.object).isRequired,
  editor: propTypes.shape({
    resolveController: propTypes.func,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  activePlan: state.userInfoReducer.activePlan,
  subscriptionStatus: state.userInfoReducer.subscriptionStatus,
  formatType: state.editResumeFormReducer.formatType,
});

export default connect(mapStateToProps)(Rating);
